import { useState, useEffect } from 'react'
import { Alert, Table  } from 'reactstrap'
import { gql } from '@apollo/client'
import { handleGraphQLErrors } from '../../../utils.js'
import Spinner from '../../Spinner/Spinner.js'
import { USAGE_REPORT_QUERY } from '../../../graphql.js'
import SchemaReport from './SchemaReport.js'

export const USAGE_REPORT = gql(USAGE_REPORT_QUERY)

export default function UsageReport(props) {
  console.log('UsageReport rendered: ', props)

  const [showSpinner, setShowSpinner] = useState(false)
  const [reportData, setReportData] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const today = new Date()
  const sevenDaysAgo = new Date(today)
  sevenDaysAgo.setDate(today.getDate() - 7)
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
  const todayString = new Intl.DateTimeFormat('en-US', options).format(today)
  const sevenDaysAgoString = new Intl.DateTimeFormat('en-US', options).format(sevenDaysAgo)

  useEffect(() => {
    async function fetchReport() {
      console.log('UsageReport.useEffect.fetchReport')
      try {
        setShowSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: USAGE_REPORT })
        if (data.usageReport) {
          //console.log(data.getLogFile)
          setReportData(data.usageReport)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setShowSpinner(false)
      }
    }
    if (!reportData && graphQLErrors.length === 0) {
      fetchReport()
    }
  }, [reportData, graphQLErrors])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger" style={{ marginTop: '50px'}}>{graphQLErrors[0].message}</Alert>
  } else if (showSpinner) {
    return <Spinner />
  } else if (reportData) {
    let schemas = []
    for (let schema of reportData) {
      schemas.push(<SchemaReport key={schema.schema} schema={schema} />)
    }
    return (
      <div style={{ height: '100%', overflow: 'auto', padding: '10px' }}>
        <div style={{ padding: '10pxs' }}>
          <h4 style={{ paddingBottom: '10px' }}>{`Usage Report (${sevenDaysAgoString} - ${todayString})`}</h4>
          <Table bordered size="sm" style={{ width: 'auto' }}>
            {schemas}
          </Table>
        </div>
      </div>
    )
  }
  return ''
}
